import { render, staticRenderFns } from "./ContainerView.vue?vue&type=template&id=381a0c12"
import script from "./ContainerView.vue?vue&type=script&lang=js"
export * from "./ContainerView.vue?vue&type=script&lang=js"
import style0 from "./ContainerView.vue?vue&type=style&index=0&id=381a0c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports